module.exports = __webpack_public_path__ + "static/media/jwt.1b2de92d.svg";